import React from 'react';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import SearchIcon from '@material-ui/icons/Search';
import { CORES } from '../theme';

/**
 * Barra de filtros padrão.
 * - Todos os filtros aplicam juntos ao clicar em Pesquisar ou apertar Enter.
 * - `ativos` vira uma linha de chips ("Cliente: X ✕") com o link Limpar.
 *
 * <FilterBar onPesquisar={fn} onLimpar={fn} ativos={[{ rotulo: "Estado: SP", remover: fn }]}>
 *   <Grid container spacing={2}>...campos...</Grid>
 * </FilterBar>
 */
const FilterBar = ({ children, onPesquisar, onLimpar, ativos = [], extra }) => {
    const enviar = (evt) => {
        evt.preventDefault();
        onPesquisar();
    };

    return (
        <Paper variant="outlined" style={{ padding: 16, marginBottom: 12 }}>
            <form onSubmit={enviar} style={{ display: 'flex', flexWrap: 'wrap', gap: 16, alignItems: 'flex-end' }}>
                <div style={{ flex: '999 1 480px', minWidth: 0 }}>{children}</div>
                <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                    {extra}
                    <Button type="submit" variant="contained" color="primary" startIcon={<SearchIcon />}>
                        Pesquisar
                    </Button>
                </div>
            </form>
            {ativos.length > 0 && (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center', marginTop: 12, fontSize: 13, color: CORES.textoSuave }}>
                    <span>Filtros:</span>
                    {ativos.map((f) => (
                        <Chip
                            key={f.rotulo}
                            size="small"
                            label={f.rotulo}
                            onDelete={f.remover}
                            style={{ background: CORES.verdeClaro, color: '#1F4615', fontWeight: 600 }}
                        />
                    ))}
                    {onLimpar && (
                        <Button size="small" onClick={onLimpar}>
                            Limpar
                        </Button>
                    )}
                </div>
            )}
        </Paper>
    );
};

export default FilterBar;
